const Quotes = () => import('../Quotes.vue')

const quotes_routes = [
    {
        path: '/quotes',
        name: '/quotes',
        component: Quotes,
        meta: {
            layout: 'mystagit'
        }
    },
]

export default quotes_routes
